module.exports = __webpack_public_path__ + "img/customer-a-060.e2435192.png";